var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkcheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0425258,
    y: 0.542526,
    width: 32.9149,
    height: 32.9149,
    rx: 16.4575,
    fill: "#3D3D3D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0425258,
    y: 0.542526,
    width: 32.9149,
    height: 32.9149,
    rx: 16.4575,
    stroke: "white",
    strokeWidth: 0.0850515
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11768 16.9999L11.7778 22.2537C12.5791 23.1571 13.9921 23.1498 14.7839 22.2381L25.2353 10.2058",
    stroke: "white",
    strokeWidth: 3.23529,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkcheck);
export default __webpack_public_path__ + "static/media/markcheck.86c775cbe516f94e3527d3fb34be50e5.svg";
export { ForwardRef as ReactComponent };